import {
    combineReducers
} from 'redux';
import inAssessmentReducer from './inAssessmentReducer';
import inResultsReducer from './inResultsReducer';

const SelectedFiltersReducer = combineReducers({
    inAssessment: inAssessmentReducer,
    inResults: inResultsReducer,
});

export default SelectedFiltersReducer;